export const LoadingContent = () => {
  return <div className="Note">Loading…</div>;
};
